import { decodeJwtPayloadUnsafe, isJwtExpired } from './session/jwt.js';

export type AuthBffDebugScope = 'refresh' | 'jwt';

function isDebugEnabled(): boolean {
  const value = process.env.AUTH_BFF_DEBUG;
  if (!value) return false;
  const normalized = value.trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
}

export function authBffDebug(
  scope: AuthBffDebugScope,
  message: string,
  data?: Record<string, unknown>,
): void {
  if (!isDebugEnabled()) return;

  const prefix = `[auth-bff:${scope}]`;
  if (data) {
    console.log(prefix, message, data);
  } else {
    console.log(prefix, message);
  }
}

export function sessionTokenMeta(
  token: string | null | undefined,
  bufferSec: number,
): {
  present: boolean;
  length: number;
  sub?: string;
  exp?: number;
  expired?: boolean;
} {
  if (!token) {
    return { present: false, length: 0 };
  }

  const payload = decodeJwtPayloadUnsafe(token);
  const expired = isJwtExpired(token, bufferSec);

  return {
    present: true,
    length: token.length,
    ...(typeof payload?.sub === 'string' ? { sub: payload.sub } : {}),
    ...(typeof payload?.exp === 'number' ? { exp: payload.exp } : {}),
    expired,
  };
}

export function refreshTokenMeta(token: string | null | undefined): {
  present: boolean;
  length: number;
} {
  if (!token) {
    return { present: false, length: 0 };
  }

  return { present: true, length: token.length };
}
